export class FormTransaction {
  id: number;
  formId: number;
  formData: string;
  status: number;
  memberId: number;
  memberName: string;
  userId: string;
  
  paymentRequired: boolean;
  paymentUrl: string;
  paymentTransactionId: number | null;
  paymentCompleted: boolean;
  paymentAmount: number;
  paymentDate: Date;

  createdBy: string;
  creationDate: Date;
}